import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

export const ErrorApp404 = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100vh - 164px)',
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Typography variant="h1" color="primary" gutterBottom>
        404
      </Typography>
      <Typography variant="h4" color="text.secondary">
        Page Not Found
      </Typography>
      <Typography variant="body1" color="text.secondary" mt={2}>
        The page you're looking for doesn't exist.
      </Typography>
    </Box>
  );
};